module.exports = __webpack_public_path__ + "img/dage.1eae7119.jpg";